var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBridge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 3333,
  height: 640,
  viewBox: "0 0 3333 640",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 480h2500V0H0Z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.33333 0 0 -1.33333 0 640)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBridge);
export default ForwardRef;